import { createStore } from "effector";
import { withPersist } from "effector-persist";
import { pipe } from "rambda";

const createPersistedStore = pipe(createStore, withPersist);

export { createPersistedStore };
